import { Link } from "react-router-dom";

/**
 * TermsCheckbox — reusable legal-consent gate.
 *
 * Renders a blank, opt-in checkbox linked to the caller's local state.
 * The parent MUST disable its submit button when `checked === false`.
 *
 * Data-testid: `${testid}` on the input so tests can drive it.
 */
export default function TermsCheckbox({ checked, onChange, testid = "terms-checkbox" }) {
  return (
    <label className="flex items-start gap-2 text-xs text-slate-600 select-none cursor-pointer">
      <input
        type="checkbox"
        className="mt-0.5 h-4 w-4 rounded border-slate-300 text-sky-600 focus:ring-sky-500"
        checked={!!checked}
        onChange={(e) => onChange(e.target.checked)}
        data-testid={testid}
      />
      <span>
        I agree to the{" "}
        <Link to="/legal/privacy" target="_blank" rel="noreferrer"
              className="text-sky-600 hover:underline" data-testid="terms-privacy-link">
          Privacy Policy
        </Link>{" "}
        and{" "}
        <Link to="/legal/terms" target="_blank" rel="noreferrer"
              className="text-sky-600 hover:underline" data-testid="terms-tnc-link">
          Terms &amp; Conditions
        </Link>{" "}
        of UpchaarQ.
      </span>
    </label>
  );
}
